<template>
    <div>
        <div v-if="loading">
            <svg class="mt-12 h-12 w-12 animate-spin mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>

        <div v-else>

            <div v-if="methods.length == 0">
                {{ __('home::checkout.no_delivery_methods_for_you_location') }}
            </div>

            <div v-else>
                <div>
                    <label
                        class="w-full flex items-center font-medium text-gray-700 cursor-pointer mb-2 border border-gray-200 p-4"
                        :class="{
                            'bg-primary-light': item.id == method,
                        }"
                        v-for="item in methods"
                    >
                        <input
                            class="rounded-full border-gray-300 text-primary shadow-sm focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
                            type="radio"
                            name="delivery_method_id"
                            :checked="item.id == method"
                            :value="item.id"
                            @change="$emit('update:method', $event.target.value)"
                        >
                        <div class="flex-grow flex justify-between items-center ml-2 text-gray-600">
                            <span>
                                {{ item.name }}
                                ({{ formatPrice(item.prices[order.currency] * (1 + order.vat_rate), order.currency) }})
                            </span>
                            <img
                                :src="item.provider_logo_path"
                                class="h-3"
                                :alt="item.provider_name"
                            />
                        </div>
                    </label>
                </div>
            </div>

            <div v-if="servicepointsCanBeShown && addressIsSelected && order.delivery_method?.select_servicepoint">

                <br>

                <div class="flex items-center justify-between mb-4">
                    <strong>{{ __('home::checkout.servicepoint') }}</strong>

                    <button type="button" class="inline-block border-b border-primary border-dashed text-primary text-sm mb-1" @click="getServicepoints()">
                        {{ __('home::checkout.refresh') }}
                    </button>
                </div>

                <div v-if="servicepointsResult?.servicepoints?.length == 0">
                    {{ __('home::checkout.no_servicepoints_available') }} <br>
                </div>

                <div v-else>

                    <label
                        class="w-full flex items-center font-medium text-gray-700 cursor-pointer mb-2 border border-gray-200 p-4"
                        :class="{
                            'bg-primary-light': item.id == servicepoint,
                        }"
                        v-for="item in servicepointsResult.servicepoints"
                    >
                        <input
                            class="rounded-full border-gray-300 text-primary shadow-sm focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
                            type="radio"
                            name="delivery_servicepoint_id"
                            :checked="item.id == servicepoint"
                            :value="item.id"
                            @change="$emit('update:servicepoint', $event.target.value)"
                        >
                        <div class="w-full ml-4">
                            <div class="text-gray-600 leading-tight">{{ item.name }}</div>
                            <div class="flex items-end justify-between mt-1">
                                <div class="text-xs text-gray-400">
                                    <div>{{ item.address }}</div>
                                    <div>{{ item.zipcode }} {{ item.city }}</div>
                                </div>
                                <div class="text-gray-400">
                                    <div>{{ item.distanceKm }} km</div>
                                </div>
                            </div>
                        </div>
                    </label>

                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        props: {
            order: {
                type: Object,
            },
            form: {
                type: Object,
            },
            method: {
                type: [String, Number],
                default: null,
            },
            servicepoint: {
                type: [String, Number],
                default: null,
            },
        },
        data() {
            return {
                loading: false,
                methods: [],
                servicepointsResult: [],
                servicepointsCanBeShown: false,
            };
        },
        mounted() {
            this.getMethods();
            if (this.order.delivery_method && this.order.delivery_method.select_servicepoint) {
                this.getServicepoints();
            }
        },
        watch: {
            'form.customer_country': function (newVal, oldVal) {
                this.getMethods();
            },
            method: function (newVal, oldVal) {
                this.updateMethod(newVal);
            },
        },
        computed: {
            addressIsSelected() {
                return this.form.customer_address != ''
                    && this.form.customer_zipcode != ''
                    && this.form.customer_city != ''
                    && this.form.customer_country != '';
            }
        },
        methods: {
            getMethods() {

                let request = {
                    weight: this.order.weight,
                    country: this.form.customer_country,
                };

                this.loading = true;

                axios
                    .post(this.$route('home::delivery.methods'), request)
                    .then((res) => {
                        this.methods = res.data;
                        this.loading = false;
                    });

            },
            getServicepoints() {

                if (! this.addressIsSelected) {
                    return;
                }

                if (! this.order.delivery_method?.select_servicepoint) {
                    return;
                }

                let request = {
                    address: this.form.customer_address,
                    zipcode: this.form.customer_zipcode,
                    city: this.form.customer_city,
                    country: this.form.customer_country,
                    delivery_method_id: this.method,
                };

                this.servicepointsCanBeShown = true;
                this.loading = true;

                axios
                    .post(this.$route('home::delivery.service-points'), request)
                    .then((res) => {
                        this.servicepointsResult = res.data;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.servicepointsResult = [];
                        this.loading = false;
                    });

            },
            updateMethod(id) {

                let request = {
                    delivery_method_id: id,
                }

                this.loading = true;

                axios
                    .post(this.$route('home::checkout.update-delivery-method'), request)
                    .then((res) => {
                        var order = res.data;
                        this.$emit('update:order', order);
                        this.loading = false;

                        if (order.delivery_method?.select_servicepoint) {
                            this.getServicepoints(order);
                        }
                    });

            },
        },
    }
</script>
